import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { RoutingConfig } from '@app/routing/routing.config';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { PageHeaderService } from './page-header.service';
import { DevicesClass } from '@app/core/classes';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'shared-page-header',
  templateUrl: 'page-header.component.html',
  styleUrls: [`./page-header.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})

export class PageHeaderComponent extends DevicesClass implements OnInit {
  public Routing = RoutingConfig;

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef,
    private router: Router,
    private componentService: PageHeaderService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.onMobileSlideout();
  }

  onMobileSlideout(): void {
    this.componentService.onSlideoutClear();

    this.router.events.pipe(untilDestroyed(this)).subscribe((e: RouterEvent) => {
      if (e instanceof NavigationEnd) {
        this.componentService.onSlideoutMenuClose();
        this.componentService.onSlideoutProfileClose();
        this.componentService.onSlideoutClear();
      }
    });

    this.componentService.onSlideout();
  }

  onMobileMenuView(): void {
    this.componentService.onSlideoutMenuToggle();
  }

  onMobileProfileView(): void {
    this.componentService.onSlideoutProfileToggle();
  }


}
